import { createRoot } from "react-dom/client";
import App from "./app/App";
import "./index.css";

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("#root element not found — check index.html");
}
createRoot(rootEl).render(<App />);
